import { render, staticRenderFns } from "./EventosInterno.vue?vue&type=template&id=3f883276&scoped=true&"
import script from "./EventosInterno.vue?vue&type=script&lang=js&"
export * from "./EventosInterno.vue?vue&type=script&lang=js&"
import style0 from "./EventosInterno.vue?vue&type=style&index=0&id=3f883276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f883276",
  null
  
)

export default component.exports